<template>
  <section>
    <section
      class="unload-box"
      v-for="(item, index) in cityCustomerOrders"
      :key="index"
    >
      <section class="unload-content">
        <span class="title-1">卸货点-{{ index + 1 }}</span>
        <div class="content-1" :title="item.desAddressDtl">
          <div>{{ item.desAddressDtl }}</div>
        </div>
        <span class="title-2">到达时限</span>
        <div class="content-2">
          <span>{{ item.requiredTime }}小时</span>
        </div>
      </section>

      <section class="unload-content">
        <span class="title-3">地址名称</span>
        <div class="content-3" :title="item.desAddressName">
          <span>{{ item.desAddressName }}</span>
        </div>
        <span class="title-4">货物数量</span>
        <div class="content-4">
          <span
            >{{ item.quantityShipped }}{{ item.quantityShippedUnitName }}</span
          >
        </div>
      </section>
    </section>
    <template v-if="cityCustomerOrdersIsChange">
      <!-- <section class="unload-box modify">
        <section class="unload-content">
          <span class="title-1">已修改卸货点</span>
        </section>
      </section> -->

      <section
        class="unload-box modify"
        v-for="(item, index) in cityCustomerOrderVers"
        :key="item.ccoId"
      >
        <section class="unload-content">
          <span class="title-1">卸货点-{{ index + 1 }}</span>
          <div class="content-1" :title="item.desAddressDtl">
            <div>{{ item.desAddressDtl }}</div>
          </div>
          <span class="title-2">到达时限</span>
          <div class="content-2">
            <span>{{ item.requiredTime }}小时</span>
          </div>
        </section>

        <section class="unload-content">
          <span class="title-3">地址名称</span>
          <div class="content-3" :title="item.desAddressName">
            <span>{{ item.desAddressName }}</span>
          </div>
          <span class="title-4">货物数量</span>
          <div class="content-4">
            <span
              >{{ item.quantityShipped
              }}{{ item.quantityShippedUnitName }}</span
            >
          </div>
        </section>
      </section>
    </template>
  </section>
</template>

<script>
export default {
  props: {
    cityCustomerOrders: {
      type: Array,
      default: () => [],
    },
    cityCustomerOrderVers: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    cityCustomerOrdersIsChange () {
      let isChange = false;
      if (this.cityCustomerOrders.length && this.cityCustomerOrderVers.length) {
        if (this.cityCustomerOrders.length === this.cityCustomerOrderVers.length) {
          // 卸货点个数相等，需要对比每一个点的数据是否有修改
          const arr1 = this.cityCustomerOrders.map((item) => ({
            desAddressDtl: item.desAddressDtl,
            requiredTime: item.requiredTime,
            desAddressName: item.desAddressName,
            quantityShipped: item.quantityShipped,
            quantityShippedUnitName: item.quantityShippedUnitName,
            sourceAddressNavigationLat: item.sourceAddressNavigationLat,
            sourceAddressNavigationLng: item.sourceAddressNavigationLng,
          }));
          const arr2 = this.cityCustomerOrderVers.map((item) => ({
            desAddressDtl: item.desAddressDtl,
            requiredTime: item.requiredTime,
            desAddressName: item.desAddressName,
            quantityShipped: item.quantityShipped,
            quantityShippedUnitName: item.quantityShippedUnitName,
            sourceAddressNavigationLat: item.sourceAddressNavigationLat,
            sourceAddressNavigationLng: item.sourceAddressNavigationLng,
          }));
          if (JSON.stringify(arr1) !== JSON.stringify(arr2)) {
            isChange = true;
          }
        } else {
          // 卸货点个数不相等，证明有修改
          isChange = true;
        }
      }
      return isChange;
    },
  },
};
</script>

<style lang="scss" scoped>
.unload-box {
  margin-right: -24px;
  margin-left: -24px;
  display: flex;
  border-bottom: 1px solid #e0e0e0;
  &.modify {
    color: red;
  }
  &:last-child {
    border-bottom: none;
  }
  .unload-content {
    flex: 1;
    display: flex;
    .title-1,
    .title-2,
    .title-3,
    .title-4 {
      width: 100px;
      background: #fafafa;
    }
    .title-1 {
      width: 160px;
      margin-left: 24px;
    }
    .title-2,
    .title-3,
    .title-4 {
      text-align: center;
    }
    .content-1,
    .content-3 {
      flex: 1;
      width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .content-2,
    .content-4 {
      width: 100px;
      text-align: center;
    }
  }
}
</style>
